import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const getDriverById = id =>
  privateAxios({
    method: 'get',
    baseURL: adminAPI,
    url: `/driver/${id}`,
  });
